import React, { useState,useEffect } from 'react';
import './Login.css';
import LoadingOverlay from './LoadingOverlay';

function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [mfaCode, setMfaCode] = useState('');
  const [tempToken, setTempToken] = useState('');
  const [step, setStep] = useState('credentials'); // 'credentials' or 'mfa'
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [notice, setNotice] = useState(null);

  useEffect(() => {
    const reason = sessionStorage.getItem('logout_reason');
    if (reason === 'expired') {
      setNotice('Your session has expired. Please sign in again.');
    }
    sessionStorage.removeItem('logout_reason');
  }, []);

  const handleCredentialsSubmit = async (e) => {
    
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch('https://dcn-backend.onrender.com/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || 'Login failed');
      } else {
        setTempToken(data.tempToken); // token for MFA stage
        setStep('mfa');
      }
    } catch {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  };

  const handleMfaSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
  
    if (!tempToken) {
      setError('Session expired. Please log in again.');
      setLoading(false);
      setStep('credentials');
      return;
    }
  
    try {
      console.log("Submitting MFA:", { token: tempToken, code: mfaCode });
  
      const response = await fetch('https://dcn-backend.onrender.com/login/mfa', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: tempToken, code: mfaCode })
      });
  
      const data = await response.json();
  
      if (!response.ok) {
        setError(data.error || 'Invalid MFA code');
      } else {
        localStorage.setItem('accessToken', data.token); // ← store it
        onLogin(data.token);
      }

      
    } catch {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div className="login-container">
      {loading && <LoadingOverlay />}

      {notice && (
        <div className="login-banner" role="status">
          {notice}
        </div>
      )}

      <form onSubmit={step === 'credentials' ? handleCredentialsSubmit : handleMfaSubmit} className="login-form">
        <h3 style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <span style={{ color: '#97B464', fontFamily: 'Arial Black, sans-serif', fontSize: '2rem' }}>DC</span>
          <span style={{ color: 'white', fontFamily: 'Arial, sans-serif' }}>Nav</span>
        </h3>

        {error && <p className="login-error">{error}</p>}

        {step === 'credentials' ? (
          <>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required />
          </>
        ) : (
          <>
            <p style={{ textAlign: 'center', color: 'white' }}>
              Enter the 6-digit code from your authenticator app.
            </p>
            <input
              type="text"
              placeholder="MFA Code"
              value={mfaCode}
              onChange={(e) => setMfaCode(e.target.value)}
              required
              maxLength={6}
              pattern="\d{6}" />
          </>
        )}

        <button type="submit">{step === 'credentials' ? 'Next' : 'Verify Code'}</button>
      </form>

      <div
        className="position-absolute"
        style={{
          bottom: '10px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 1,
          position: 'absolute'
        }}
      >
        <img
          src="/logo.png"
          alt="Logo"
          className="img-fluid"
          style={{ maxWidth: '70px' }}
        />
      </div>
    </div>
  );
}

export default Login;
